import React from 'react';
import classnames from 'classnames';
import { formatDateStr } from '@gp/utils/common';

import type { IBaseProps } from '@home/types/common';

interface IPanelHeaderProps extends IBaseProps {
  date: string;
  num: number;
}

const getProjectsLabel = (len = 0): string => {
  const domainLabel = len > 1 ? 'Projects' : 'Project';
  return `${len} ${domainLabel}`;
};

const PanelHeader: React.FC<IPanelHeaderProps> = (props) => {
  const { style, className, date, num } = props;

  return (
    <div style={style} className={classnames('dbg-dps-report-hightlights-panel-header', className)}>
      <div className="dbg-dps-report-hightlights-panel-header__date">{formatDateStr(date, 'ddd (MM-DD)')}</div>
      <div className="dbg-dps-report-hightlights-panel-header__num">{getProjectsLabel(num)}</div>
      <div className="dbg-dps-report-hightlights-panel-header__line"></div>
    </div>
  );
};

export default PanelHeader;
